import DocumentsActionsCell from '../components/DocumentsActionsCell';

export default [
    {
        title: 'Name',
        key: 'DisplayName',
        minWidth: 80,
    },

    {
        title: 'Attachment',
        width: 80,
        align: 'center',
        render: (h, params) => {
            return h('div', [
                h(DocumentsActionsCell, {
                    props: {
                        row: params.row
                    }
                }),
            ]);
        }
    },

    {
        title: 'Document Type',
        key: 'description',
        minWidth: 80,
    },

    {
        title: 'Uploaded On',
        key: 'UploadedOn',
        minWidth: 80,
    },

    {
        title: 'Uploaded By',
        key: 'UploadedBy',
        minWidth: 80,
    },
    
    {
        title: 'Notes',
        key: 'Notes',
        minWidth: 80,
    }
]
